import type { ServiceCaseStatus } from '../../../shared/types'

const statusStyles: Record<ServiceCaseStatus, string> = {
  open: 'bg-blue-100 text-blue-700',
  in_progress: 'bg-indigo-100 text-indigo-700',
  waiting_customer: 'bg-amber-100 text-amber-700',
  waiting_parts: 'bg-orange-100 text-orange-700',
  resolved: 'bg-green-100 text-green-700',
  closed: 'bg-gray-100 text-gray-600',
}

const statusLabels: Record<ServiceCaseStatus, string> = {
  open: 'Open',
  in_progress: 'In Progress',
  waiting_customer: 'Waiting on Customer',
  waiting_parts: 'Waiting for Parts',
  resolved: 'Resolved',
  closed: 'Closed',
}

export function ServiceCaseStatusBadge({ status }: { status: ServiceCaseStatus }) {
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ${statusStyles[status]}`}>
      {statusLabels[status]}
    </span>
  )
}
